import { defineNuxtPlugin, useRouter } from "#app";

/*
  Delegated click handler for "never"-hydrated blocks whose <a> tags stay inert.
  Hands same-origin clicks to the router; interaction hydration can't replace it
  because Vue re-dispatches without preventDefault.

  Opt out: rel="external" per link, or data-spa-links="false" per subtree
  (propagation must not stop — argus tracks clicks on document and document.body).
*/
export default defineNuxtPlugin(() => {
  const router = useRouter();

  document.addEventListener("click", (event) => {
    const plainLeftClick =
      event.button === 0 &&
      !event.defaultPrevented &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey;
    if (!plainLeftClick) {
      return;
    }

    const anchor = (event.target as Element | null)?.closest<HTMLAnchorElement>(
      "a[href]:not([download]):not([target])",
    );
    if (
      !anchor ||
      anchor.relList.contains("external") ||
      anchor.closest('[data-spa-links="false"]')
    ) {
      return;
    }

    // In-page anchors stay native — ContentJumplinks renders `#id` and relies on the
    // browser's hash jump, which router.push would replace with its own scroll behaviour.
    const href = anchor.getAttribute("href");
    if (!href || href.startsWith("#")) {
      return;
    }

    const url = new URL(anchor.href);
    if (url.origin !== location.origin) {
      return;
    }

    event.preventDefault();
    void router.push(url.pathname + url.search + url.hash);
  });
});
